<article class="teaser {{type}}">
  <figure class="teaser__crop {{type}}__crop" *ngIf="data.iconUrl || data.logoUrl">
    <img [src]="data.iconUrl || data.logoUrl" alt="" />
  </figure>

  <div class="teaser__content {{type}}__content">
    <span class="teaser__content__meta {{type}}__content__meta" *ngIf="data.date">{{data.date | date:'MMMM yyyy'}}</span>
    <span class="teaser__contentent__meta {{type}}__content__meta type--order" *ngIf="data.order">{{data.order}}</span>
    <h1 class="{{type}}__content__title" >{{data.title}}</h1>
    <p class="{{type}}__content__text" *ngIf="data.text">{{data.text}}</p>
  </div>

  <a href="{{data.url}}" class="block-link {{type}}__button button" *ngIf="data.url"></a>

</article>
